module.exports = __webpack_public_path__ + "img/vicon8.43e3410c.png";